import { Either, isLeft } from 'fp-ts/lib/Either'

export * from 'fp-ts/lib/Either'
export { Either as Type } from 'fp-ts/lib/Either'

/**
 * Unsafe get the value of `ma` - throwing `E` if it is a `Left`
 * @param ma Either<E,A>
 * @returns A
 * @throws E
 */
export function unsafeGet<L, A>(ma: Either<L, A>) {
  if (isLeft(ma)) {
    throw ma.left
  } else {
    return ma.right
  }
}
